import { GetRecordsResponseViewFragment } from 'generated/graphql';
import { useMapFeedback } from 'v2/core/repository/edge-server/utils/records';
import useUpdateFeedbacks from 'v2/core/services/records/updateFeedback';
import { useGetUser } from 'v2/core/services/user';

export const useGetFeedbacksFromResponse = (
  records?: GetRecordsResponseViewFragment,
) => {
  const {
    tenant: { timezone },
  } = useGetUser();
  const mappedFeedbacks = useMapFeedback(timezone, records?.records, undefined);
  const feedbackRecords = useUpdateFeedbacks(mappedFeedbacks);

  return {
    feedbackRecords,
    hits: records?.hits,
  };
};
